import { Col, Row } from "react-bootstrap";
import EpaCard from "../../../../../leap-components/EpaCard";
import EpaField from "../../../../../leap-components/EpaField";

import { INotifierDetails } from "../../../../../api/CircularEconomy/INotifiers";
import { formatDate } from "../../../../../api/DateUtils";

interface NotifierDetailsProp {
  notifierDetails: INotifierDetails;
}

const EowDetails = ({ notifierDetails }: NotifierDetailsProp) => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Registration Reference"}
            value={notifierDetails.reg_no}
          />
          <EpaField label={"Operator"} value={notifierDetails.notifier_name} />
          <EpaField
            label={"Date Received"}
            value={formatDate(notifierDetails.date_received)}
          />
          <EpaField label={"Status"} value={notifierDetails.status} />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return <EpaCard title={"Registration Details"} content={bodyElements} />;
};

export default EowDetails;
